/**
 * @description product mutations
 */
import {types} from '../constants/types'
import {PayHelpers} from '../../utils/payHelper'

// 修改动作Keys
const {SET_SECOND_PAYMETHOD_LIST, SELECT_SECOND_PAYMENT, UPDATE_ORDER_LIST, CLEAR_ORDER_LIST, UPDATE_SKU_LIST, SET_PAYMETHOD_LIST, SELECT_PAYMENT, SET_SKU_DETAIL} = types

export default {
  [UPDATE_SKU_LIST](state, data) {
    state.skuList = []
    data.forEach((val) => {
      if (val.paramList) {
        val = Object.assign({}, val, JSON.parse(val.paramList))
      }
      state.skuList.push(val)
    })
  }
  , [SET_SKU_DETAIL](state, data) {
    state.skuDetail = Object.assign({}, data)
  }
  // 更新支付方式列表
  , [SET_PAYMETHOD_LIST](state, {payMethodList}) {
    state.payMethodList = payMethodList
  }
  // 选择支付方式
  , [SELECT_PAYMENT](state, {index}) {
    let {payMethodList, payEnv} = state
    state.paySelectedIndex = index
    // console.log(payMethodList[index])
    state.paymentSubCode = PayHelpers.determinPaySubCode(payMethodList[index], payEnv)
  }
  // 二次支付支付方式
  , [SET_SECOND_PAYMETHOD_LIST](state, data) {
    state.secondPayMethodsList = data
  },
  // 选择二次支付方式
  [SELECT_SECOND_PAYMENT](state, {index}) {
    let {secondPayMethodsList, payEnv} = state
    state.secondPaySelectedIndex = index
    state.secondPaymentSubCode = PayHelpers.determinPaySubCode(secondPayMethodsList[index], payEnv)
  }
  // 订单列表
  , [UPDATE_ORDER_LIST](state, data) {
    let {orderList} = state
    let dataInfo = {};
    data.forEach((item, index) => {
      let { orderId } = item;
      if (!dataInfo[orderId]) {
        dataInfo[orderId] = {
          id: index,
          ...item,
          productName: item.reProductName || item.productName,
          orderId,
          child: []
        }
      }
      dataInfo[orderId].child.push(item);
    });
    const list1 = Object.values(dataInfo);
    state.orderList = Object.assign([], orderList.concat(list1))
  }
  , [CLEAR_ORDER_LIST](state) {
    state.orderList = []
  }
}
